// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-flooring-pdp.liquid so the browser can cache it. Code unchanged apart from one thing:
// the ten per-product values that Liquid used to print inside this script (description, pack size, sold per, GST flag, the
// Get a price flags, the price list, title and handle) now come from window.adoreCfg_fpdp, which the snippet sets just before
// this file loads. The small Get a price card script from the end of the snippet follows, in its original order.
  (function () {
    var C = window.adoreCfg_fpdp || {}; // the per-product values Liquid used to write straight into this script
    // Pack size (m² per box) from the product description, same patterns tested on all flooring products
    var desc = C.desc;
    var pats = [
      /Pack(?: size)?\s*:\s*(?:\d+\s*(?:boards|pieces|planks|blocks)\s*,\s*)?(\d+(?:\.\d+)?)\s*(?:m²|m2|sqm)/i,
      /(\d+(?:\.\d+)?)\s*(?:m²|m2|sqm)\s*(?:per\s*(?:box|pack|carton)|pack)/i,
      /(?:pack|box)[^.]{0,40}?cover(?:s|ing)?\s*(\d+(?:\.\d+)?)\s*(?:m²|m2|sqm)/i,
      /pack (?:holds|is) \d+ \w+, (\d+(?:\.\d+)?)\s*(?:m²|m2|sqm)/i
    ];
    var pack = parseFloat(C.pack) || 0;
    for (var i = 0; i < pats.length && !pack; i++) { var m = desc.match(pats[i]); if (m) pack = parseFloat(m[1]); }
    if (!(pack > 0.3 && pack < 6)) pack = 0;
    var perBox = C.soldPer === 'box' && pack > 0;
    /* 10 Oct 2026 (Yass: "lets do exact box and gst at checkout"). Products with metafield adore.price_inc_gst = true
       have a price that INCLUDES GST, so checkout charges the full amount. With adore.sold_per = "box" that price is one
       box, and the cart quantity is boxes, so the order is charged for the exact boxes. The page then leads with the price
       per m² including GST and shows the box price under it. Products without the flag keep the old wording
       ("excludes GST", GST on the invoice) until their price is changed. */
    var inc = C.inc;
    /* 15 Oct 2026: "Get a price" flooring flags (see the Liquid at the top) */
    var NP = C.np, NPFROM = C.npFrom, NPINC = C.npInc;

    function money(c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function num(v) { v = parseFloat(String(v).replace(',', '.')); return isFinite(v) && v > 0 ? v : 0; }

    var prices = C.prices;
    var NOTES = {
      /* 5b. the delivery line lives here now (was a separate line under the price) */
      diy: 'You lay it yourself. Free pickup from Auburn, or delivery quoted for your boxes and address.',
      byoi: 'Your installer lays it and we help them through the job. Free pickup from Auburn, or delivery quoted for your boxes and address.',
      install: 'We measure, quote and install across Sydney. The measure and quote are free and there is no obligation.'
    };
    function buildCalc() {
      if (document.querySelector('.adore-calc')) return;
      var tpl = document.getElementById('adore-calc-tpl');
      var atc = document.querySelector('.product-page-info [data-js-product-button-add-to-cart]');
      var anchor = atc && atc.closest('.form');
      if (!tpl || !anchor) return;
      var parent = anchor.parentNode;
      var priceBlock = document.querySelector('.product-page-info__price');
      if (!priceBlock || priceBlock.parentNode !== parent) priceBlock = null;
      // 5b. (28 Sep) unit beside the price: "$49.00 per m², excludes GST"; route pills AFTER the price
      if (priceBlock && !priceBlock.querySelector('.adore-unit')) {
        var un = document.createElement('span'); un.className = 'adore-unit';
        un.textContent = inc ? 'per m², includes GST' : (perBox ? 'per box' : 'per m²') + ', excludes GST';
        var pr0 = priceBlock.querySelector('[data-js-product-price]') || priceBlock;
        pr0.parentNode.insertBefore(un, pr0.nextSibling);
      }
      var rt = document.getElementById('adore-routes-tpl');
      var afterPrice = priceBlock || anchor;
      if (rt) parent.insertBefore(rt.content.cloneNode(true), afterPrice.nextSibling);
      var routes = document.querySelector('[data-routes]');
      var pnote = routes || afterPrice; /* the old separate price note is gone; later blocks follow the routes */
      // calculator next, then the quantity box + Add to cart, then one confirm line
      parent.insertBefore(tpl.content.cloneNode(true), pnote.nextSibling);
      var box = document.querySelector('.adore-calc');
      parent.insertBefore(anchor, box.nextSibling);
      var qlab = document.createElement('p'); qlab.className = 'adore-qty-label';
      qlab.textContent = pack ? 'Your area (m²)' : 'Quantity (m²)';
      anchor.insertBefore(qlab, anchor.firstChild);
      var confirm = document.createElement('p'); confirm.className = 'adore-confirm';
      // 9 Oct 2026 (Yass): ask customers to contact us before ordering, to check stock and book pickup or delivery
      confirm.innerHTML = 'Before you order, call or text <a href="tel:0483939938">0483 939 938</a> to check stock and book your pickup or delivery.';
      parent.insertBefore(confirm, anchor.nextSibling);
      // "Supply and install": the buy button becomes a jump to the measure and quote form
      var qform = document.getElementById('contact_form');
      var qcta = document.createElement('a'); qcta.className = 'adore-quote-cta'; qcta.hidden = true;
      qcta.href = qform ? '#contact_form' : '/pages/free-flooring-measure-quote';
      qcta.textContent = 'Book a free measure and quote';
      parent.insertBefore(qcta, confirm.nextSibling);
      if (qform) qcta.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: qform.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' }); var f = qform.querySelector('input:not([type=hidden]),textarea'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 600); });

      var price = parseInt(box.getAttribute('data-price'), 10) || 0;
      var qty = document.querySelector('.product-page-info [name="quantity"]');
      var roomsEl = box.querySelector('[data-rooms]');
      var out = box.querySelector('[data-out]');
      var err = box.querySelector('[data-err]');
      var need = 0, route = 'diy';
      function curPrice() { var i = document.querySelector('.product-page-info [name="id"]'); var p = i && prices[String(i.value)]; return p || price; }
      var perM2 = perBox ? price / pack : price;
      function m2(v) { return String(+v.toFixed(2)); } /* 5d. 1.09375 shows as 1.09 */
      box.querySelector('[data-calc-packline]').textContent = pack
        ? (perBox ? 'Sold by the box. Each box covers ' + m2(pack) + ' m² and costs ' + money(price) + (inc ? ', including GST.' : '.')
                  : 'Each box covers ' + m2(pack) + ' m². We supply whole boxes.')
        : 'Enter your room sizes in metres.';
      if (perBox && inc) {
        /* 10 Oct 2026: price per m² (incl. GST) in place of the theme's box price, box price under it */
        var pri = document.querySelector('.product-page-info__price');
        if (pri && !document.querySelector('.adore-incp')) {
          var cmp = parseInt(box.getAttribute('data-compare'), 10) || 0;
          pri.classList.add('adore-inc');
          var ip = document.createElement('div'); ip.className = 'adore-incp';
          ip.innerHTML = '<span class="adore-incp__now">' + money(Math.round(perM2)) + '</span>' +
            (cmp > price ? ' <s class="adore-incp__was">' + money(Math.round(cmp / pack)) + '</s>' : '') +
            ' <span class="adore-unit">per m², includes GST</span>' +
            '<span class="adore-incp__box">' + money(price) + ' per box of ' + m2(pack) + ' m²</span>';
          pri.insertBefore(ip, pri.firstChild);
          var fb = document.querySelector('.js-footbar-product [data-js-product-price]');
          if (fb && !fb.querySelector('.adore-fbu')) { var fu = document.createElement('span'); fu.className = 'adore-fbu'; fu.style.cssText = 'font-size:12px;font-weight:400;margin-left:4px'; fu.textContent = 'per box, incl. GST'; fb.appendChild(fu); }
        }
      } else if (perBox) {
        var pr = document.querySelector('.product-page-info__price');
        if (pr && !document.querySelector('.adore-perm2')) {
          var d = document.createElement('div'); d.className = 'adore-perm2';
          d.style.cssText = 'font-size:14px;color:#1D1A17;margin-top:4px;';
          d.innerHTML = '<strong>' + money(perM2) + ' per m²</strong> (price shown is per box of ' + m2(pack) + ' m²)';
          pr.appendChild(d);
        }
      }
      box.querySelector('input[name="adore-waste"][value="' + (box.getAttribute('data-herring') ? '20' : '10') + '"]').checked = true;

      // Add to cart label shows the total for the cart quantity: "Add to cart, $686"
      var atcText = atc.querySelector('.btn__text') || atc;
      function unit(n) { return perBox ? (n === 1 ? ' box' : ' boxes') : ' m²'; }
      function label() {
        est(); /* 12 Oct 2026: keep the estimate in step with the m² box and the variant */
        if (!qty) return;
        var n = parseInt(qty.value, 10) || 1;
        if (atc.disabled) { return; }
        var c = n * curPrice(); /* whole dollars when there are no cents, so the label fits on one line */
        /* 28 Sep: m² now shows in the box beside the button, so the label is just the total (one line on phones) */
        atcText.textContent = 'Add to cart, ' + (c % 100 ? money(c) : '$' + (c / 100).toLocaleString('en-AU'));
      }

      // 5f. (28 Sep, Yass) m² box that takes decimals and rounds UP to whole boxes.
      //     The theme's whole-number box (hidden) still carries the cart quantity:
      //     boxes when the product is sold per box, otherwise the whole m² that covers those boxes.
      var m2wrap = document.createElement('div'); m2wrap.className = 'adore-m2';
      m2wrap.innerHTML = '<button type="button" data-step="-1" aria-label="' + (pack ? 'One box less' : 'One m² less') + '">&minus;</button>' +
        '<input type="number" inputmode="decimal" min="0" step="0.01" aria-label="Area in square metres"><span>m²</span>' +
        '<button type="button" data-step="1" aria-label="' + (pack ? 'One box more' : 'One m² more') + '">+</button>';
      var m2in = m2wrap.querySelector('input');
      var qwrap = qty && qty.closest('.product-page-info__quantity');
      if (qwrap) qwrap.parentNode.insertBefore(m2wrap, qwrap);
      var boxLine = document.createElement('p'); boxLine.className = 'adore-boxes'; boxLine.setAttribute('aria-live', 'polite');
      var rowEl = m2wrap.closest('.d-flex');
      if (rowEl) rowEl.parentNode.insertBefore(boxLine, rowEl.nextSibling);
      /* 12 Oct 2026: money estimate under the box line, e.g. "Estimate: $1,316.25 ex GST for 15 boxes. Delivery quoted separately."
         Boxed per m² ranges: covered m² x price per m². Sold per box: boxes x box price. Carpet: m² x price per m².
         The same text goes into the quick quote form's contact[Boxes and area] field so the shop email carries it. */
      var estLine = document.createElement('p'); estLine.className = 'adore-est'; estLine.setAttribute('aria-live', 'polite');
      if (rowEl) rowEl.parentNode.insertBefore(estLine, boxLine.nextSibling);
      function estText() {
        var pc = curPrice(); if (!(pc > 0)) return '';
        /* 17 Oct 2026 (panel audit): GST is explained once, here. The box line above no longer repeats it.
           e.g. "Estimate: $63.00 for 1 box, plus GST (added to the invoice we send you). Delivery quoted separately." */
        var gst = inc ? ', including GST' : ', plus GST (added to the invoice we send you)';
        if (pack) {
          var cov = parseFloat(m2(curBx * pack));
          var tot = perBox ? curBx * pc : Math.round(cov * pc);
          return 'Estimate: ' + money(tot) + ' for ' + curBx + (curBx === 1 ? ' box' : ' boxes') + gst + '. Delivery quoted separately.';
        }
        var n = parseInt(qty && qty.value, 10) || 1;
        return 'Estimate: ' + money(n * pc) + ' for ' + n + ' m²' + gst + '.';
      }
      function est() {
        var t = estText(); if (estLine.textContent !== t) estLine.textContent = t;
        var f = document.querySelector('#adore-invoice [data-inv-qty]');
        if (f && typeof invSummary === 'function') f.value = invSummary();
      }
      var prop = null; /* box count on the order line, for picking: "Boxes: 12 (13.13 m²)" */
      if (pack) { prop = document.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[Boxes]'; anchor.appendChild(prop); }
      var curBx = 1;
      /* 5 Oct 2026 15:54 (Yass): small orders. When rounding down to the whole m2 would give away more than 10% of what
         the boxes cover (usually 1 or 2 boxes, e.g. one 1.77 m2 box charged as 1 m2), the Add to cart button is swapped for a
         note asking the customer to call or text for the exact box price; we send a separate invoice. */
      var smallNote = document.createElement('p'); smallNote.className = 'adore-small-order'; smallNote.hidden = true;
      smallNote.style.cssText = 'margin:10px 0 4px;padding:12px 14px;border:1px solid #EAE3D9;border-radius:10px;background:#F7F3EE;font-size:14px;line-height:1.45;color:#1D1A17;';
      if (rowEl) rowEl.parentNode.insertBefore(smallNote, boxLine.nextSibling);
      var atcWrap = atc.closest('.product-page-info__button-add-to-cart') || atc;
      var isSmall = false;
      /* 9 Oct 2026 (Yass): the Add to cart button no longer hides on any box count (it was hiding on 1, 2 and 5 boxes of a
         1.35 m2 range). The box note now shows on every boxed order and says "Orders are priced by the box" (was "Small orders"). */
      function setSmall(on, bx, cover) {
        isSmall = false;
        smallNote.hidden = !(bx > 0 && !perBox) || !!document.getElementById('adore-inv-tpl');
        atcWrap.style.display = '';
        if (bx > 0 && !perBox) smallNote.innerHTML = '<strong>Orders are priced by the box.</strong> For ' + bx + (bx === 1 ? ' box' : ' boxes') + ' (' + m2(cover) + ' m²), call or text <a href="tel:0483939938" style="color:#1D1A17;text-decoration:underline;font-weight:600">0483 939 938</a> and we will send you an invoice for the exact amount.';
      }
      anchor.addEventListener('submit', function (e) { if (isSmall) { e.preventDefault(); e.stopPropagation(); } }, true);
      function fromM2(v) {
        /* 5 Oct 2026 02:20 (Nas): boxed flooring sold per m² is charged on the whole m² BELOW what the boxes cover
           (15 boxes covering 26.55 m² = charged 26 m²), so nobody pays for flooring they do not receive. Was rounded up.
           Carpet (no box size) still rounds up, because it is cut to the room. */
        if (pack) { var bx = Math.max(1, Math.ceil(v / pack - 1e-9)); return { bx: bx, q: perBox ? bx : Math.max(1, Math.floor(bx * pack + 1e-9)) }; }
        var q = Math.max(1, Math.ceil(v - 1e-9)); return { bx: 0, q: q };
      }
      function setQty(q) {
        if (!qty || String(qty.value) === String(q)) return;
        qty.value = q; qty.dispatchEvent(new Event('input', { bubbles: true })); qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      function apply(v, snap) {
        v = num(v); if (!v) return;
        var r = fromM2(v); curBx = r.bx;
        setQty(r.q);
        if (pack) {
          var cover = r.bx * pack;
          if (snap) m2in.value = m2(cover);
          boxLine.textContent = r.bx + (r.bx === 1 ? ' box' : ' boxes') + ', covering ' + m2(cover) + ' m²' +
            // 9 Oct 2026 (Yass): checkout does not add GST; it goes on the invoice we send the customer
            // 9 Oct 2026 01:34 (Yass): "You pay for X m², rounded down" removed. Not true: the invoice covers the exact m² of the boxes.
            // 17 Oct 2026 (panel audit): GST now explained once, in the estimate line below
            '.';
          prop.value = r.bx + ' (' + m2(cover) + ' m²)';
          setSmall(!perBox && (cover - r.q) / cover > 0.1, r.bx, cover);
        } else if (snap) { m2in.value = r.q; }
        label();
      }
      m2in.addEventListener('input', function () { apply(m2in.value, false); });
      m2in.addEventListener('change', function () { apply(m2in.value, true); });
      m2wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-step]'); if (!b) return;
        var s = parseInt(b.getAttribute('data-step'), 10);
        if (pack) apply(Math.max(1, curBx + s) * pack, true);
        else apply(Math.max(1, (parseInt(qty.value, 10) || 1) + s), true);
      });
      (function () { var last = ''; setInterval(function () { var i = document.querySelector('.product-page-info [name="id"]'); var k = (i ? i.value : '') + '|' + (qty ? qty.value : ''); if (k !== last) { last = k; label(); } }, 400); })();
      apply(pack || 1, true); /* start at one box (or 1 m² for carpet) */

      /* 10 Oct 2026 (Yass): invoice request in place of Add to cart (see the template comment above) */
      var invTpl = document.getElementById('adore-inv-tpl');
      var invMode = !!invTpl && price > 0;
      var invBtn = null, invPanel = null, invForm = null;
      if (invMode) {
        document.documentElement.classList.add('adore-inv-mode');
        invBtn = document.createElement('button'); invBtn.type = 'button'; invBtn.className = 'adore-btn-p adore-inv-btn';
        invBtn.setAttribute('aria-expanded', 'false'); invBtn.setAttribute('aria-controls', 'adore-inv-panel');
        invBtn.textContent = 'Get a quick quote';
        var atcBox = atc.closest('.product-page-info__button-add-to-cart') || atc;
        atcBox.parentNode.insertBefore(invBtn, atcBox.nextSibling);
        invPanel = document.createElement('div'); invPanel.id = 'adore-inv-panel'; invPanel.className = 'adore-inv'; invPanel.hidden = true;
        invPanel.appendChild(invTpl.content.cloneNode(true));
        parent.insertBefore(invPanel, anchor.nextSibling);
        invForm = invPanel.querySelector('form');
        confirm.innerHTML = 'No payment online. For an immediate quote and stock check, call or text <a href="tel:0483939938">0483 939 938</a>.';
        var invSuburb = invPanel.querySelector('[data-inv-suburb]');
        invPanel.addEventListener('change', function (e) {
          if (e.target.name === 'contact[Pick up or delivery]') {
            var del = /^Delivery/.test(e.target.value);
            invSuburb.hidden = !del; invSuburb.querySelector('input').required = del;
          }
        });
        /* 15 Oct 2026 (Yass): the "No payment online..." line under the button hides while the panel is open (the panel has
           its own fine print) and comes back when the panel is closed. The button now toggles the panel. */
        function syncConfirm() { confirm.hidden = !invPanel.hidden; }
        new MutationObserver(syncConfirm).observe(invPanel, { attributes: true, attributeFilter: ['hidden'] });
        function closeInv() { invPanel.hidden = true; invBtn.setAttribute('aria-expanded', 'false'); syncConfirm(); }
        function openInv() {
          invPanel.hidden = false; invBtn.setAttribute('aria-expanded', 'true'); syncConfirm();
          var s = invPanel.querySelector('[data-inv-sum]'); if (s) s.textContent = invSummary();
          window.scrollTo({ top: invPanel.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
          var r = invPanel.querySelector('input[type=radio]'); if (r) setTimeout(function () { r.focus({ preventScroll: true }); }, 500);
        }
        invBtn.addEventListener('click', function () { if (invPanel.hidden) openInv(); else closeInv(); }); /* 15 Oct 2026: toggles */
        /* Enter in the m² box, or the sticky bar's button, no longer adds to cart: it opens the request */
        anchor.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); openInv(); }, true);
        document.addEventListener('click', function (e) {
          var fb = e.target.closest('.footbar-product [data-js-product-button-add-to-cart]');
          if (fb) { e.preventDefault(); e.stopPropagation(); openInv(); }
        }, true);
        invForm.addEventListener('submit', function () {
          var q = invSummary();
          invForm.querySelector('[data-inv-qty]').value = q;
          var pick = invForm.querySelector('input[name="contact[Pick up or delivery]"]:checked');
          var sub = invForm.querySelector('#adore-inv-suburb');
          invForm.querySelector('[data-inv-body]').value = 'Quick quote and stock check: ' + C.title + '. ' + q + '. ' +
            (pick ? pick.value : '') + (sub && sub.value ? ', ' + sub.value : '') + '. ' + (invForm.querySelector('[data-inv-note]').value || '');
          try { sessionStorage.setItem('adoreInvSent', C.handle); } catch (err) {}
          if (window.gtag) window.gtag('event', 'adore_quote_request', { item_name: C.title, route: pick ? pick.value : '' });
        });
        var sent = false; try { sent = /[?&]contact_posted=true/.test(location.search) && sessionStorage.getItem('adoreInvSent') === C.handle; if (sent) sessionStorage.removeItem('adoreInvSent'); } catch (err) {}
        if (sent) {
          var ok = document.createElement('div'); ok.className = 'adore-inv__ok'; ok.setAttribute('role', 'status');
          /* 15 Oct 2026 (Yass): 2 hours during business hours (was 1 business day) */
          ok.innerHTML = '<strong>Thanks, we\'re on it.</strong> We\'ll check stock and email your quote within 1 hour on weekdays, or 2 to 3 hours on weekends, during business hours. For an immediate quote and stock check, call or text <a href="tel:0483939938">0483 939 938</a>.';
          parent.insertBefore(ok, anchor.nextSibling);
          /* the theme's own red "Thanks for contacting us" pop-up would say it twice: close it when it appears */
          document.documentElement.classList.add('adore-inv-sent');
          var tries = 0, closer = setInterval(function () {
            var c = document.querySelector('.popup-contact-confirmation [data-js-popup-close]');
            if (c && c.offsetParent) { c.click(); clearInterval(closer); }
            if (++tries > 40) clearInterval(closer);
          }, 250);
          setTimeout(function () { window.scrollTo({ top: ok.getBoundingClientRect().top + window.scrollY - 140 }); }, 300);
        }
        if (invPanel.querySelector('.adore-inv__err')) { invPanel.hidden = false; invBtn.setAttribute('aria-expanded', 'true'); syncConfirm(); }
        var fbBtn = document.querySelector('.footbar-product [data-js-product-button-add-to-cart]');
        if (fbBtn) { var fbT = fbBtn.querySelector('.btn__text') || fbBtn; fbT.textContent = 'Get a quick quote'; }
      }
      function invSummary() {
        var n = parseInt(qty && qty.value, 10) || 1;
        /* 12 Oct 2026: the estimate rides along in contact[Boxes and area] */
        var e = estText(); e = e ? '. ' + e.replace(/\.$/, '') : '';
        if (pack) return curBx + (curBx === 1 ? ' box' : ' boxes') + ', covering ' + m2(curBx * pack) + ' m²' + e;
        return n + ' m²' + e;
      }

      // 5e. phones: floating Call / Free quote / Text us hide while any part of the buy box is on screen
      if ('IntersectionObserver' in window) {
        var seen = new Set();
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
          document.documentElement.classList.toggle('adore-buy-inview', seen.size > 0);
        });
        /* 6 Oct 2026: also the price beat block and the free measure form block */
        var acts = [].slice.call(document.querySelectorAll('.product-page-info__custom-liquid')).filter(function (b) { return b.querySelector('#competitor-quote-btn, #contact_form'); });
        [routes, box, anchor].concat(acts).forEach(function (el) { if (el) io.observe(el); });
      }

      function setRoute(r) {
        route = r;
        [].forEach.call(routes ? routes.querySelectorAll('[data-route]') : [], function (b) { var on = b.getAttribute('data-route') === r; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (routes) routes.querySelector('[data-route-note]').textContent = NOTES[r];
        document.documentElement.classList.toggle('adore-route-install', r === 'install');
        qcta.hidden = r !== 'install';
        box.querySelector('[data-calc-note]').innerHTML = r === 'install'
          ? 'This estimate is for supply only. Installation is quoted after the free measure.'
          : 'Fills the m² box below. Rather we measure? <a href="/pages/free-flooring-measure-quote">Book a free measure</a>.';
      }
      if (routes) routes.addEventListener('click', function (e) { var b = e.target.closest('[data-route]'); if (b) setRoute(b.getAttribute('data-route')); });
      setRoute('diy');

      function addRoom() {
        var n = roomsEl.children.length + 1;
        var row = document.createElement('div');
        row.className = 'adore-calc__row';
        row.innerHTML = '<input type="number" inputmode="decimal" min="0" step="0.1" placeholder="Length" aria-label="Room ' + n + ' length in metres"> <span class="adore-calc__x">m ×</span> ' +
          '<input type="number" inputmode="decimal" min="0" step="0.1" placeholder="Width" aria-label="Room ' + n + ' width in metres"> <span class="adore-calc__x">m</span>' +
          (n > 1 ? ' <button type="button" class="adore-calc__rm" aria-label="Remove room">×</button>' : '');
        roomsEl.appendChild(row);
      }
      addRoom();

      function bad(inp) { return (inp.validity && inp.validity.badInput) || (inp.value !== '' && !(parseFloat(inp.value) > 0)); }
      function calc() {
        var area = 0, invalid = false;
        [].forEach.call(roomsEl.children, function (r) { var ins = r.querySelectorAll('input'); if (bad(ins[0]) || bad(ins[1])) invalid = true; area += num(ins[0].value) * num(ins[1].value); });
        err.hidden = !invalid;
        var w = parseInt((box.querySelector('input[name="adore-waste"]:checked') || {}).value || '10', 10);
        if (!area) { need = 0; out.textContent = 'Enter your room size to see the boxes and the price.'; return; }
        var withW = area * (1 + w / 100);
        var p = curPrice();
        var wLine = w ? 'Floor area ' + area.toFixed(2) + ' m² + ' + w + '% = ' + withW.toFixed(2) + ' m²' : 'Floor area ' + area.toFixed(2) + ' m²';
        var r = fromM2(withW); need = r.q;
        /* 12 Oct 2026: boxed ranges priced per m² now show covered m² x price, the same figure as the estimate line under the m² box (was whole m² below the cover) */
        var tot = pack ? (perBox ? r.bx * p : Math.round(parseFloat(m2(r.bx * pack)) * p)) : r.q * p;
        var html = '<span class="adore-calc__big">About ' + money(tot) + '</span><br>' +
          (pack ? r.bx + ' box' + (r.bx === 1 ? '' : 'es') + ', covering ' + m2(r.bx * pack) + ' m²' : 'Order ' + r.q + ' m²') +
          '<br><span style="color:#57504A">' + wLine + '</span>';
        out.innerHTML = html;
        // the result goes straight into the m² box, so the button below reads the same total
        apply(pack ? r.bx * pack : withW, true);
      }

      box.addEventListener('input', calc);
      box.addEventListener('change', calc);
      box.addEventListener('click', function (e) {
        var t = e.target;
        if (t.matches('[data-addroom]')) { addRoom(); }
        else if (t.matches('.adore-calc__rm')) { t.closest('.adore-calc__row').remove(); calc(); }
      });
    }


    /* 15 Oct 2026 (Yass): "Get a price" flooring (no price shown) gets the same layout as priced flooring: "Price on request"
       (or the range's "From" price) where the price goes, the route pills, a green "Get a price" button that opens the same
       quick quote panel (Request "Price request"), the same line under it (hidden while the panel is open), and "Supply and
       install" swaps the button for "Book a free measure and quote". The theme's buy box is not rendered on these pages. */
    function buildNoPrice() {
      if (!NP || document.querySelector('.adore-np-price')) return;
      var info = document.querySelector('.product-page-info'); if (!info) return;
      var title = info.querySelector('.product-page-info__title'); if (!title || title.parentNode !== info) return;
      document.documentElement.classList.add('adore-np');
      [].forEach.call(info.querySelectorAll('.product-page-info__icon-with-text'), function (el) { if (/for pricing/i.test(el.textContent)) el.classList.add('adore-np-hide'); });
      var gp = info.querySelector('.adore-gp'); if (gp) gp.parentNode.removeChild(gp);
      var pr = document.createElement('div'); pr.className = 'adore-np-price';
      pr.innerHTML = NPFROM > 0
        ? '<span class="adore-np-price__from">From</span> <span class="adore-np-price__v">' + money(NPFROM) + '</span> <span class="adore-unit">per m², ' + (NPINC ? 'includes' : 'excludes') + ' GST</span>'
        : '<span class="adore-np-price__v">Price on request</span>';
      info.insertBefore(pr, title.nextSibling);
      var rt = document.getElementById('adore-routes-tpl');
      if (rt) info.insertBefore(rt.content.cloneNode(true), pr.nextSibling);
      var routes = info.querySelector('[data-routes]');
      var buy = document.createElement('div'); buy.className = 'adore-np-buy';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'adore-btn-p adore-inv-btn';
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', 'adore-inv-panel'); btn.textContent = 'Get a price';
      buy.appendChild(btn);
      info.insertBefore(buy, (routes || pr).nextSibling);
      var panel = document.createElement('div'); panel.id = 'adore-inv-panel'; panel.className = 'adore-inv'; panel.hidden = true;
      var itpl = document.getElementById('adore-inv-tpl'); if (itpl) panel.appendChild(itpl.content.cloneNode(true));
      info.insertBefore(panel, buy.nextSibling);
      var confirm = document.createElement('p'); confirm.className = 'adore-confirm';
      confirm.innerHTML = 'No payment online. For an immediate quote and stock check, call or text <a href="tel:0483939938">0483 939 938</a>.';
      info.insertBefore(confirm, panel.nextSibling);
      var qform = document.getElementById('contact_form');
      var qcta = document.createElement('a'); qcta.className = 'adore-quote-cta'; qcta.hidden = true;
      qcta.href = qform ? '#contact_form' : '/pages/free-flooring-measure-quote';
      qcta.textContent = 'Book a free measure and quote';
      info.insertBefore(qcta, confirm.nextSibling);
      if (qform) qcta.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: qform.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' }); var f = qform.querySelector('input:not([type=hidden]),textarea'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 600); });

      var form = panel.querySelector('form');
      var area = null;
      if (form) {
        var setv = function (n, v) { var i = form.querySelector('[name="' + n + '"]'); if (i) i.value = v; };
        setv('contact[Request]', 'Price request');
        setv('contact[tags]', 'price-request,flooring');
        setv('contact[Price]', NPFROM > 0 ? 'Price on request (range from ' + money(NPFROM) + ' per m², ' + (NPINC ? 'incl.' : 'ex') + ' GST)' : 'Price on request');
        var hh = form.querySelector('.adore-inv__h'); if (hh) hh.textContent = 'Get a price';
        var ld = form.querySelector('.adore-inv__lead'); if (ld) ld.textContent = 'Pick up or delivery, roughly how much you need, your details. Takes about a minute.';
        var nameL = form.querySelector('label[for="adore-inv-name"]');
        if (nameL) {
          var al = document.createElement('label'); al.setAttribute('for', 'adore-np-area'); al.textContent = 'Area needed in m² (optional)';
          area = document.createElement('input'); area.id = 'adore-np-area'; area.type = 'text'; area.setAttribute('inputmode', 'decimal'); area.placeholder = 'e.g. 25';
          nameL.parentNode.insertBefore(al, nameL); nameL.parentNode.insertBefore(area, nameL);
        }
        var sub = panel.querySelector('[data-inv-suburb]');
        panel.addEventListener('change', function (e) {
          if (e.target.name === 'contact[Pick up or delivery]' && sub) {
            var del = /^Delivery/.test(e.target.value);
            sub.hidden = !del; sub.querySelector('input').required = del;
          }
        });
        form.addEventListener('submit', function () {
          var a = area ? area.value.trim() : '';
          var q = a ? a.replace(/\s*(m²|m2|sqm)\s*$/i, '') + ' m²' : 'Area not given';
          form.querySelector('[data-inv-qty]').value = q;
          var pick = form.querySelector('input[name="contact[Pick up or delivery]"]:checked');
          var sb = form.querySelector('#adore-inv-suburb');
          form.querySelector('[data-inv-body]').value = 'Price request: ' + C.title + '. ' + q + '. ' +
            (pick ? pick.value : '') + (sb && sb.value ? ', ' + sb.value : '') + '. ' + (form.querySelector('[data-inv-note]').value || '');
          try { sessionStorage.setItem('adoreInvSent', C.handle); } catch (err) {}
          if (window.gtag) window.gtag('event', 'adore_price_request', { item_name: C.title, route: pick ? pick.value : '' });
        });
      }
      function sync() { confirm.hidden = !panel.hidden; }
      new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      function openP(scroll) {
        panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); sync();
        if (!scroll) return;
        window.scrollTo({ top: panel.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
        var r = panel.querySelector('input[type=radio]'); if (r) setTimeout(function () { r.focus({ preventScroll: true }); }, 500);
      }
      function closeP() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); sync(); }
      btn.addEventListener('click', function () { if (panel.hidden) openP(true); else closeP(); });
      if (panel.querySelector('.adore-inv__err')) openP(false);
      var sent = false; try { sent = /[?&]contact_posted=true/.test(location.search) && sessionStorage.getItem('adoreInvSent') === C.handle; if (sent) sessionStorage.removeItem('adoreInvSent'); } catch (err) {}
      if (sent) {
        var ok = document.createElement('div'); ok.className = 'adore-inv__ok'; ok.setAttribute('role', 'status');
        ok.innerHTML = '<strong>Thanks, we\'re on it.</strong> We\'ll check stock and email your quote within 1 hour on weekdays, or 2 to 3 hours on weekends, during business hours. For an immediate quote and stock check, call or text <a href="tel:0483939938">0483 939 938</a>.';
        info.insertBefore(ok, buy.nextSibling);
        var tries = 0, closer = setInterval(function () {
          var c = document.querySelector('.popup-contact-confirmation [data-js-popup-close]');
          if (c && c.offsetParent) { c.click(); clearInterval(closer); }
          if (++tries > 40) clearInterval(closer);
        }, 250);
      }
      function setRoute(r) {
        [].forEach.call(routes ? routes.querySelectorAll('[data-route]') : [], function (b) { var on = b.getAttribute('data-route') === r; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (routes) routes.querySelector('[data-route-note]').textContent = NOTES[r];
        document.documentElement.classList.toggle('adore-route-install', r === 'install');
        qcta.hidden = r !== 'install';
      }
      if (routes) routes.addEventListener('click', function (e) { var b = e.target.closest('[data-route]'); if (b) setRoute(b.getAttribute('data-route')); });
      setRoute('diy');
      /* phones: the floating Call / Free quote / Text us bar steps aside while these are on screen, as on priced pages */
      if ('IntersectionObserver' in window) {
        var seen = new Set();
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
          document.documentElement.classList.toggle('adore-buy-inview', seen.size > 0);
        });
        [routes, buy, panel].forEach(function (el) { if (el) io.observe(el); });
      }
    }

    // Price beat: replace the blank-email click with three clear ways to send the quote
    function fixPriceBeat() {
      var btn = document.getElementById('competitor-quote-btn');
      if (!btn) return;
      /* 24 Oct 2026 (Nas): the template prints "PRICE BEAT REQUEST" in capitals with its own red inline style. Sentence case
         and no inline style, so it takes the same outline button look as the other secondary buttons (assets/adore-buttons.css).
         The panel with the text, email and call links only appears on the first tap, as before. */
      btn.textContent = 'Price beat request';
      btn.removeAttribute('style');
      btn.classList.remove('btn-danger');
      var title = C.title;
      var msg = 'Price beat request for ' + title + '. I have a competitor quote, photo attached.';
      btn.onclick = function (e) {
        e.preventDefault();
        var p = document.querySelector('.adore-pb');
        if (p) { p.hidden = !p.hidden; return; }
        p = document.createElement('div');
        p.className = 'adore-pb';
        p.innerHTML = '<p>Send us the other store\'s quote and we will beat it. A photo or screenshot is fine.</p>' +
          '<a href="sms:0483939938?&body=' + encodeURIComponent(msg) + '">Text a photo of the quote: 0483 939 938</a>' +
          '<a href="mailto:info@adorerugs.com.au?subject=' + encodeURIComponent('Price beat request: ' + title) + '">Email it: info@adorerugs.com.au</a>' +
          '<a href="tel:0291663980">Call us: 02 9166 3980</a>';
        btn.parentNode.insertBefore(p, btn.nextSibling);
      };
    }

    /* 3 Oct 2026 (panel re-audit, item 3):
       a. the description (PRODUCT INFORMATION tab) moves up to sit before the price beat button and the quote form,
          so a shopper reads what the board is before being asked for a quote;
       b. the quote form drops to four short fields (name, mobile, email, suburb) with the message optional and a line
          saying what happens next. Shopify's contact form needs the email field, so it stays;
       c. the empty Judge.me box ("Be the first to write a review") is hidden on flooring pages;
       d. the price beat sentence no longer reads "Flooring flooring". */
    function tidyFlooringPage() {
      var info = document.querySelector('.product-page-info'); if (!info) return;
      var tabs = document.querySelector('.product-page__tabs');
      var blocks = [].slice.call(info.querySelectorAll('.product-page-info__custom-liquid'));
      var pb = blocks.filter(function (b) { return b.querySelector('#competitor-quote-btn'); })[0];
      var qf = blocks.filter(function (b) { return b.querySelector('#contact_form'); })[0];
      var first = pb || qf;
      if (tabs && first) { tabs.classList.add('adore-tabs-up'); first.parentNode.insertBefore(tabs, first); }
      var sentence = pb && pb.querySelector('#competitor-quote-btn + p');
      if (sentence) sentence.textContent = 'Found it cheaper? Send us the written quote and we will beat it.';
      var form = qf && qf.querySelector('form#contact_form');
      if (form && !form.querySelector('.adore-qf')) {
        var hidden = [].slice.call(form.querySelectorAll('input[type=hidden]'));
        var notice = form.querySelector('.form-message, .errors, .note, .form__message');
        form.innerHTML = '';
        hidden.forEach(function (h) { form.appendChild(h); });
        if (notice) form.appendChild(notice);
        var wrap = document.createElement('div'); wrap.className = 'adore-qf';
        wrap.innerHTML =
          /* 15 Oct 2026 (Yass): 2 hours during business hours (was one business day) */
          /* 23 Oct 2026 (Nas): reply promise 1 hour on weekdays, 2 to 3 hours on weekends. "Sydney metro only" removed: we
             measure within about 55 km of Auburn and travel further for larger jobs. Suburb became Postcode, checked the same
             way as the free measure page (adore-postcode-gate); the result goes in the email as "Service area". */
          '<p class="adore-qf__lead">Tell us where you are and we will call to book your free measure, within 1 hour on weekdays, or 2 to 3 hours on weekends, during business hours.</p>' +
          '<div class="adore-qf__grid">' +
          '<label><span>Name</span><input type="text" name="contact[name]" required autocomplete="name"></label>' +
          '<label><span>Mobile</span><input type="tel" name="contact[phone]" required autocomplete="tel" inputmode="tel"></label>' +
          '<label><span>Email</span><input type="email" name="contact[email]" required autocomplete="email" inputmode="email"></label>' +
          '<label><span>Postcode</span><input type="text" name="contact[postcode]" required autocomplete="postal-code" inputmode="numeric" maxlength="4" pattern="[0-9]{4}" data-adore-qf-pc></label>' +
          '</div>' +
          '<p class="adore-qf__area" data-adore-qf-area aria-live="polite"></p><input type="hidden" name="contact[Service area]" data-adore-qf-sa>' +
          '<details class="adore-qf__more"><summary>Add a note (optional)</summary><textarea name="contact[body]" rows="3" placeholder="Rooms, timing, or anything else"></textarea></details>' +
          '<button type="submit" class="btn adore-qf__btn">Book a free measure</button>';
        form.appendChild(wrap);
        /* 23 Oct 2026: postcode check, same area list as snippets/adore-postcode-gate.liquid (keep the two in step) */
        (function () {
          var AREA = [[2000,2234],[2250,2251],[2256,2257],[2508,2508],[2515,2516],[2555,2571],[2745,2779]];
          function inNsw(n) { return n >= 2000 && n <= 2999 && !(n >= 2600 && n <= 2618) && !(n >= 2900 && n <= 2920); }
          function inArea(n) { for (var i = 0; i < AREA.length; i++) { if (n >= AREA[i][0] && n <= AREA[i][1]) return true; } return false; }
          var pc = wrap.querySelector('[data-adore-qf-pc]'), msg = wrap.querySelector('[data-adore-qf-area]'), sa = wrap.querySelector('[data-adore-qf-sa]');
          if (!pc || !msg || !sa) return;
          pc.addEventListener('input', function () {
            var v = pc.value.replace(/\D/g, '').slice(0, 4); if (pc.value !== v) pc.value = v;
            if (v.length < 4) { msg.textContent = ''; sa.value = ''; return; }
            var n = Number(v);
            if (inArea(n)) { msg.textContent = 'Yes, we measure and install in ' + v + '.'; sa.value = 'Within 55 km (' + v + ')'; }
            else if (!inNsw(n)) { msg.textContent = 'We install in NSW only, but we can supply this floor with freight quoted to ' + v + '.'; sa.value = 'Outside NSW, supply only (' + v + ')'; }
            else { msg.textContent = v + ' is a little outside our usual area, but we travel further for larger jobs. Send your details and we will call you.'; sa.value = 'Outside 55 km (' + v + ')'; }
            try { if (window.gtag) window.gtag('event', 'adore_postcode_check', { result: sa.value.split(' (')[0], page: 'flooring_product' }); } catch (e) {}
          });
        })();
        var h = qf.querySelector('h4, h3, h2'); if (h) h.textContent = 'Book a free measure and quote';
      }
      var qh = qf && qf.querySelector('h4, h3, h2'); if (qh) qh.id = 'adore-quote';
      /* 23 Oct 2026 (Nas, panel 22 Oct): "Recent installs in Sydney" photo strip from snippets/adore-install-strip.liquid,
         placed just before the measure and quote form */
      var it = document.getElementById('adore-installs-tpl');
      if (it && qf && !document.querySelector('.adore-installs')) qf.parentNode.insertBefore(it.content.cloneNode(true), qf);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildCalc); else buildCalc();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildNoPrice); else buildNoPrice(); /* 15 Oct 2026 */
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidyFlooringPage); else tidyFlooringPage();
    // The template's own script sets the price beat click on DOMContentLoaded, so this runs after it
    if (document.readyState === 'complete') fixPriceBeat(); else window.addEventListener('load', fixPriceBeat);
  })();
  (function () {
    function addGetPrice() {
      var info = document.querySelector('.product-page-info'); if (!info || info.querySelector('.adore-gp')) return;
      if (document.documentElement.classList.contains('adore-np')) return; /* 15 Oct 2026: "Get a price" pages now use the priced layout */
      var price = info.querySelector('.product-page-info__price'), atc = info.querySelector('[data-js-product-button-add-to-cart]');
      var priced = price && price.offsetParent !== null && /\d/.test(price.textContent);
      if (priced || (atc && atc.offsetParent !== null)) return;
      var form = document.getElementById('contact_form');
      var card = document.createElement('div'); card.className = 'adore-gp';
      card.innerHTML = '<strong>Get a price for this floor</strong>Prices for this range are given on request. Tell us roughly how many square metres you need and your suburb, and we will send you a written price.' +
        '<div class="adore-gp__btns">' + (form ? '<a class="adore-gp__main" href="#adore-quote">Get a price</a>' : '') +
        '<a href="tel:0483939938">Call 0483 939 938</a><button type="button" data-adore-gp-text>Text us</button></div>';
      var title = info.querySelector('h1'); var anchor = title ? title.closest('div') : null;
      if (anchor && anchor.parentNode === info) info.insertBefore(card, anchor.nextSibling); else if (title && title.parentNode) title.parentNode.insertBefore(card, title.nextSibling); else info.insertBefore(card, info.firstChild);
      var main = card.querySelector('.adore-gp__main');
      if (main) main.addEventListener('click', function (e) { var t = document.getElementById('adore-quote') || form; if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
      card.querySelector('[data-adore-gp-text]').addEventListener('click', function () { var b = document.querySelector('[data-adore-chat-tab]'); if (b) b.click(); else location.href = 'sms:0483939938'; });
    }
    if (document.readyState === 'complete') addGetPrice(); else window.addEventListener('load', addGetPrice);
  })();
